import { Component, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';

@Component({
    selector: 'app-dc-input',
    templateUrl: './dc-input.component.html',
    styleUrls: ['./dc-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DcInputComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class DcInputComponent extends ControlValueAccessorConnector {
  @Input() readonly: boolean;
  @Input() type: 'text' | 'number' | 'email' | 'password' | 'hidden';
  @Input() placeholder: string;
  @Input() label: string;
  @Input() id: string;
  @Input() helpText?: string;
  @Input() field: any;
  constructor(injector: Injector) {
    super(injector);
  }
}
